module.exports = __webpack_public_path__ + "img/indexLogo@180h.d1251719.png";